import { render, staticRenderFns } from "./GenderWidget.vue?vue&type=template&id=76e4f1bb&scoped=true&lang=pug&"
import script from "./GenderWidget.vue?vue&type=script&lang=js&"
export * from "./GenderWidget.vue?vue&type=script&lang=js&"
import style0 from "./GenderWidget.vue?vue&type=style&index=0&id=76e4f1bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e4f1bb",
  null
  
)

export default component.exports